var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("RestoreFileAction", {
        ref: "restoreAction",
        on: {
          reload: function ($event) {
            return _vm.reloadCapture()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "offset-y": "",
            "position-x": _vm.position.x,
            "position-y": _vm.position.y,
          },
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _c(
                "v-list-tile",
                {
                  attrs: {
                    href: `/download/${_vm.file.Id}`,
                    title: _vm.file.Name,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.downloadFile()
                    },
                  },
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("save_alt")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-tile-title", [_vm._v("Download")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "my-2" }),
              _vm._v(" "),
              _vm.isTenantAdmin
                ? _c(
                    "v-list-tile",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.restore(_vm.file.Id)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("restore")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-tile-title", [_vm._v("Restore file")]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }